// ABOUTME: Header name, storage keys and same-origin path prefixes of the per-tab active market.
// ABOUTME: Shared by the active-market store, the fetch wrapper and the Apollo link.

/** Request header carrying the tab's active market; mirrors `ACTIVE_MARKET_HEADER` on the server. */
export const ACTIVE_MARKET_HEADER = 'x-active-market';

/** Per-tab storage key: each browser tab keeps its own active market. */
export const SESSION_KEY = 'pim.activeMarket';

/** Last market used in any tab, the starting point of a tab that has none yet. */
export const LAST_MARKET_KEY = 'pim.lastMarket';

/** Only same-origin calls under these paths get the header; external URLs never do. */
export const MARKET_PATH_PREFIXES = ['/api', '/configitProxy', '/configurator'];

/** Job market argument for an explicit opt-out: the job creates unstamped records. */
export const JOB_MARKET_NONE = 'none';

/** Settings path of the market cone's opt-in list. */
export const SCOPED_HIERARCHIES_PATH = 'marketScoping.scopedHierarchyIds';
